import { render } from "./ProductoListadoModal.vue?vue&type=template&id=dd7c2f98&scoped=true"
import script from "./ProductoListadoModal.vue?vue&type=script&lang=js"
export * from "./ProductoListadoModal.vue?vue&type=script&lang=js"

import "./ProductoListadoModal.vue?vue&type=style&index=0&id=dd7c2f98&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd7c2f98"]])

export default __exports__